import React from 'react';
import { graphql } from 'gatsby';

import SectionContentMapAddressContainer from './SectionContentMapAddress';
import SectionItemContentHeadlineContainer from '../SectionItems/SectionItemContentHeadline';
import SectionItemContentMapContainer from '../SectionItems/SectionItemContentMap';
import SectionShowroomMap from '../../../components/Section/SectionShowroomMap';
import { getBackgroundImage } from '../utils';

// Types
import { SectionContentMapContainerFragment } from './__generated__/SectionContentMapContainerFragment';
import { SectionWidth } from '../../../../types/sections';

export const fragment = graphql`
  fragment SectionContentMapContainerFragment on CMS_Section {
    ...SectionContentMapAddressContainerFragment
    ...SectionItemContentHeadlineContainerFragment
    ...SectionItemContentMapContainerFragment
    backgroundColor
    backgroundPattern
    contentPositionX
    contentPositionY
    backgroundImage {
      ...SectionBackgroundImageFragment
    }
  }
`;

type Props = {
  isClipped: boolean;
  isCritical: boolean;
  isHiddenOnMobile: boolean;
  isNeighborClipped: boolean;
  section: SectionContentMapContainerFragment;
  sectionWidth: SectionWidth;
};

const SectionContentMapContainer = ({ isClipped, isCritical, isHiddenOnMobile, isNeighborClipped, section, sectionWidth }: Props) => {
  const backgroundImage = getBackgroundImage(section);

  const contentPositionX = 'flex-start';
  const contentPositionY = 'flex-start';
  const textAlign = 'start';

  const address = (
    <SectionContentMapAddressContainer
      contentPositionY={contentPositionY}
      hasBackgroundImage={!!backgroundImage}
      section={section}
      textAlign={textAlign}
    />
  );

  const headline = (
    <SectionItemContentHeadlineContainer
      contentPositionY={contentPositionY}
      hasBackgroundImage={!!backgroundImage}
      section={section}
      textAlign={textAlign}
    />
  );

  const map = <SectionItemContentMapContainer section={section} />;

  return (
    <SectionShowroomMap
      address={address}
      backgroundColor={section.backgroundColor}
      backgroundImage={backgroundImage}
      backgroundPattern={section.backgroundPattern}
      contentPositionX={contentPositionX}
      contentPositionY={contentPositionY}
      headline={headline}
      isClipped={isClipped}
      isCritical={isCritical}
      isHiddenOnMobile={isHiddenOnMobile}
      isNeighborClipped={isNeighborClipped}
      map={map}
      sectionWidth={sectionWidth}
    />
  );
};

export default SectionContentMapContainer;
